import axios from "axios";
import { BACK_API } from "apiconfig";
import { store } from "index";

const API = axios.create({ baseURL: BACK_API });
const WALLET_SUGGESTIONS_API = axios.create({
  baseURL: "https://digital-asset-advisor-eskaralakktua.replit.app",
});

export const fetchWallet = (body) => {
  const headers = {
    token: store.getState().currentUser.data.jwtToken,
    id: store.getState().currentUser.data.id,
  };
  return API.post("/balance", body, { headers: headers });
};

export const fetchWalletSuggestions = (pairs) => {
  if (!pairs) return;
  const parsedPairs = pairs.map((pair) => {
    return {
      token: pair.symbol,
      amount: pair.free,
      value_usd: pair.baseCoinValue,
    };
  });
  const body = {
    wallet: {
      assets: parsedPairs,
      preferences: {
        risk_tolerance: "medium", // optional: low, medium, high
        investment_horizon: 15, // days (default: 15)
      },
    },
  };
  return WALLET_SUGGESTIONS_API.post("/api/portfolio/analyze", body);
};
